const defaultTheme = require('tailwindcss/defaultTheme');
const aspectRatio = require('tailwindcss-aspect-ratio');
const tailwindUI = require('@tailwindcss/ui');

// See https://tailwindcss.com/docs/configuration for details
module.exports = {
  future: {
    removeDeprecatedGapUtilities: true,
    purgeLayersByDefault: true,
    defaultLineHeights: true,
    standardFontWeights: true,
  },
  purge: ['./src/**/*.js'],
  experimental: 'all',
  theme: {
    aspectRatio: {
      none: 0,
      square: [1, 1],
      '16/9': [16, 9],
      '4/3': [4, 3],
      '21/9': [21, 9],
    },
    typography: (theme) => ({
      default: {
        css: {
          color: 'inherit',
          'h1, h2, h3, h4': {
            color: 'inherit',
            fontWeight: theme('fontWeight.medium'),
            textTransform: 'uppercase',
            letterSpacing: theme('letterSpacing.wider'),
          },
          a: {
            color: 'inherit',
          },
          'ol > li:before': {
            color: theme('colors["dark-pink"]'),
            fontWeight: theme('fontWeight.medium'),
          },
          'ul > li:before': {
            backgroundColor: theme('colors["dark-pink"]'),
          },
        },
      },
    }),
    extend: {
      colors: {
        'light-pink': '#dcb1af',
        'dark-pink': '#b97773',
        'light-gray': '#efefef',
      },
      fontFamily: {
        sans: ['Jost', ...defaultTheme.fontFamily.sans],
      },
    },
  },
  // Default values here: https://tailwindcss.com/docs/pseudo-class-variants#default-variants-reference
  variants: {
    borderColor: ['responsive', 'hover', 'focus', 'group-focus'],
    boxShadow: ['responsive', 'hover', 'focus', 'group-focus'],
    margin: ['responsive', 'last'],
  },
  plugins: [
    // See https://github.com/webdna/tailwindcss-aspect-ratio for details
    aspectRatio,
    // See https://tailwindui.com/documentation for details
    tailwindUI,
  ],
};
